import OpenandCloseModal from './OpenandCloseModal';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { MdAccountCircle } from 'react-icons/md';
import { LiaStarSolid } from 'react-icons/lia';
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  getToken,
} from '../utils';

function DashboardBuyandSellOfferData() {
  const [buyandSell, setBuyandSell] = useState([]);
  const [buyOffers, setBuyOffers] = useState([]);
  const [sellOffers, setSellOffers] = useState([]);

  const { token: userToken } = getToken();

  const {
    handleOpenandCloseModal,
    setOfferDetails,
    offerDetails,
    setCxId,
    cxId,
    openModal,
  } = OpenandCloseModal();

  const getCLickedRowId = (ids) => {
    setCxId(ids);
    const selectedOffer = buyandSell?.find((data) => {
      return data.id === ids;
    });
    setOfferDetails(selectedOffer);
    handleOpenandCloseModal('offerdetails');
  };

  useEffect(() => {
    const getsellOffers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/specific-cxs`,
          {
            transaction_type_id: 2,
            transaction_status_id: 1,
          },
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        setSellOffers(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getsellOffers();
  }, [userToken]);

  useEffect(() => {
    const getBuyOffers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/specific-cxs`,
          {
            transaction_type_id: 1,
            transaction_status_id: 1,
          },
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );

        setBuyOffers(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBuyOffers();
  }, [userToken]);

  useEffect(() => {
    if (buyOffers?.length && sellOffers?.length) {
      setBuyandSell([
        ...sellOffers?.slice(0, 1),
        ...buyOffers?.slice(0, 2),
        ...sellOffers?.slice(0, 1),
        ...buyOffers?.slice(0, 1),
      ]);
    }
  }, [sellOffers, buyOffers]);

  const buyandSellOfferDataArray = buyandSell?.map((buyandSellOffers) => {
    return {
      date: `${formatDateStrToDate(buyandSellOffers?.created_at)}`,
      buyer_seller: (
        <div className='flex flex-row items-start gap-2'>
          <span className='text-4xl text-b-mc/70'>
            <MdAccountCircle />
          </span>
          <div className='flex flex-col justify-start text-left'>
            <p>{buyandSellOffers?.unique_code}</p>
            <div className='flex flex-col gap- text-sm'>
              <p className='flex flex-row items-center gap-1 text-s-bk'>
                Rating: {formatRating(buyandSellOffers?.user?.rating)}{' '}
                <span className='text-green-500 -m-1'>
                  <LiaStarSolid />
                </span>
              </p>{' '}
              {/* <p className="flex flex-row items-center gap-1 text-s-bk">
              Order: {data?.user.trx_stats?.completed}{" "}
              <span className="text-green-500 -m-1">{<BiTransfer />}</span>
            </p> */}
            </div>
          </div>
        </div>
      ),
      // currency: (
      //   <div className="flex flex-row items-center gap-2 justify-center">
      //     <img
      //       className="w-5 h-[13px]"
      //       src={buyandSellOffers?.quote_currency?.country.flag}
      //       alt="currency flag"
      //     />
      //     <p>{buyandSellOffers?.quote_currency.name}</p>
      //   </div>
      // ),
      amount: (
        <div className='flex flex-row items-center gap-2 justify-center'>
          <img
            className='w-5 h-[13px]'
            src={buyandSellOffers?.quote_currency?.country.flag}
            alt='currency flag'
          />
          <p>{`${formatAmount(buyandSellOffers?.amount)}  ${
            buyandSellOffers?.quote_currency?.symbol
          }`}</p>
        </div>
      ),
      rate: ` ${formatAmount(buyandSellOffers?.rate)}  ${
        buyandSellOffers?.base_currency.symbol
      }`,
      offertype: buyandSellOffers?.transaction_type?.name,
      action: (
        <button
          className={` text-p-wh px-4 py-1.5 rounded text-[10px] w-fit active:bg-t-bk  ${
            buyandSellOffers?.transaction_type?.name === 'Sell'
              ? 'hover:bg-red-600 bg-red-500'
              : 'hover:bg-green-600 bg-green-500'
          }`}
          onClick={() => getCLickedRowId(buyandSellOffers?.id)}
        >
          See details
        </button>
      ),
    };
  });

  return {
    buyandSellOfferDataArray,
    openModal,
    handleOpenandCloseModal,
    offerDetails,
    cxId,
  };
}

export default DashboardBuyandSellOfferData;
